import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import EmailForm from "components/shared/EmailForm";
import { useModals } from "ModalProvider";
import { SAVE_SUPPLIER } from "../../graphql";

const SupplierPortalView = ({ supplier, hideInvitation }) => {
  const modal = useModals();
  const [save] = useMutation(SAVE_SUPPLIER, {
    onCompleted() {
      Alert("success", "Saved.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function sendHandler() {
    const initialMessage = `Dear ${supplier.nickName},
尊敬的${supplier.nickName}，

You have been invited to access the Supplier Portal.
您已被邀请至Waboba供应商门户网站。

Waboba Supplier Portal is a platform where we collaborate with our suppliers. You can submit your registration information and documents through this portal.
Waboba供应商门户是我们与供应商合作的平台。您可以通过此平台提交您的注册信息和相关文件。

Here is the link 这是登录链接: ${process.env.REACT_APP_SUPPLIER_PORTAL_URL}/register

Please use the following credentials to log in:
请使用以下账号信息登录：

Username 用户名: ${supplier.user?.email}
Initial Password 初始密码: ${supplier.initialPassword}

Best regards,

Waboba Team`;

    modal.present({
      title: "Send Supplier Portal Invitation",
      children: (
        <EmailForm
          subject="Supplier Portal Invitation"
          to={[supplier.user?.email]}
          initialMessage={initialMessage}
          hide={modal.hide}
        />
      ),
    });
  }

  return (
    <div className="card">
      <h5>Supplier Portal</h5>
      <div className="opacity-70 text-xs">
        Supplier can login to the supplier portal to submit registration
        information and documents.
      </div>

      <div className="mt-2">
        {supplier.user ? (
          <div>
            <div className="mt-1 space-y-1">
              <a
                href={process.env.REACT_APP_SUPPLIER_PORTAL_URL + "/register"}
                target="_blank"
                rel="noreferrer"
              >
                {process.env.REACT_APP_SUPPLIER_PORTAL_URL}/register
              </a>

              <div>
                <label>User: </label>
                <span>{supplier.user?.email}</span>
              </div>
              <div>
                <label>Initial Password: </label>
                <span>{supplier.initialPassword}</span>
              </div>
            </div>

            {!hideInvitation && (
              <Button className="mt-4" send onClick={sendHandler}>
                Send Invitation
              </Button>
            )}

            <div className="mt-4 flex items-center space-x-2">
              <input
                id="enablePurchaseOrder"
                type="checkbox"
                checked={!!supplier.enablePurchaseOrder}
                onChange={(e) =>
                  save({
                    variables: {
                      id: supplier.id,
                      enablePurchaseOrder: e.target.checked,
                    },
                  })
                }
              />
              <label htmlFor="enablePurchaseOrder">Enable Purchase Order</label>
            </div>
          </div>
        ) : (
          <div>Not associated with any user.</div>
        )}
      </div>
    </div>
  );
};

export default SupplierPortalView;
